




















































import { Component, Prop, Vue } from 'vue-property-decorator';
import { authModule } from '@/store';
import LoginForm from '@/components/auth/LoginForm.vue';
import RegisterForm from '@/components/auth/RegisterForm.vue';

@Component({
  components: { LoginForm, RegisterForm },
})
export default class extends Vue {
  menu = [
    {
      title: 'About',
      to: {
        path: '/about/',
      },
      show: () => true,
    },
    {
      title: 'Auctions',
      to: {
        name: 'auctions',
      },
      show: () => true,
    },
    {
      title: 'Buying',
      to: {
        path: '/buying/',
      },
      show: () => true,
    },
    {
      title: 'Selling',
      to: {
        path: '/selling/',
      },
      show: () => true,
    },
    {
      title: 'Contact',
      to: {
        name: 'contact',
      },
      show: () => true,
    },
  ];

  userMenu = [
    {
      title: 'My Bids',
      to: {
        name: 'bids',
      },
      icon: 'mdi-hand',
      show: () => true,
    },
    {
      title: 'Wishlist',
      to: {
        name: 'wishlist',
      },
      icon: 'mdi-heart',
      show: () => true,
    },
    {
      title: 'Profile',
      to: {
        name: 'profile',
      },
      icon: 'mdi-account',
      show: () => true,
    },
    {
      title: 'Admin',
      to: {
        name: 'admin',
      },
      icon: 'mdi-cogs',
      show: () => authModule.isAdmin,
    },
  ];

  get filteredMenu() {
    return this.menu.filter(item => item.show());
  }

  get filteredUserMenu() {
    return this.userMenu.filter(item => item.show());
  }

  get isLoggedIn() {
    return authModule.isLoggedIn;
  }

  toggleMenu() {
    this.$emit('toggle-menu');
  }

  loginRegister() {
    authModule.openLoginDialog(null);
  }

  logout() {
    authModule.logout();
  }
}
